import React, { memo } from 'react';
import { Close } from '@mui/icons-material';
import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography
} from '@mui/material';
import { ConfirmDialogProps } from 'models';
import { dialog as dialogColors } from 'theme/colors';

const ConfirmDialog = ({
	open,
	onConfirm,
	onCancel,
	onBackdropClose,
	title,
	content,
	confirmLabel,
	cancelLabel,
	isConfirming
}: ConfirmDialogProps) => (
	<Dialog
		open={open}
		onClose={onBackdropClose ?? onCancel}
		maxWidth="sm"
		fullWidth
		sx={{ zIndex: 99999, '& .MuiDialog-paper': { bgcolor: dialogColors.paper } }}
	>
		<DialogTitle sx={{ pr: 6 }}>
			{title}
			<IconButton
				aria-label="close"
				onClick={onBackdropClose ?? onCancel}
				size="small"
				sx={{ position: 'absolute', right: 8, top: 8 }}
			>
				<Close fontSize="small" />
			</IconButton>
		</DialogTitle>
		<DialogContent>
			{typeof content === 'string' ? (
				<Typography variant="body2">{content}</Typography>
			) : (
				content
			)}
		</DialogContent>
		<DialogActions sx={{ px: 2, pb: 2 }}>
			<Button variant="outlined" onClick={onCancel} disabled={isConfirming} sx={{ padding: '5px 15px', height: 40 }}>
				{cancelLabel}
			</Button>
			<Button
				variant="contained"
				color="primary"
				onClick={onConfirm}
				disabled={isConfirming}
				startIcon={isConfirming ? <CircularProgress size={14} color="inherit" /> : undefined}
				sx={{ padding: '5px 15px', height: 40 }}
			>
				{confirmLabel}
			</Button>
		</DialogActions>
	</Dialog>
);

export default memo(ConfirmDialog);
